import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

export const SETUP_SEASON_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "SEASON",
  menuLabel: "SEASON",
  name: "setup_season",
  pageLabel: "SEASON_TITLE_SETUP",
  path: "seasons",
  hideInMenu: true,
  description: "CONF_DESC_SETUP_SEASON",
  model: {
    entityName: "short_name",
    label: "SEASON",
    path: "/api/seasons",
    name: "saison",
    attributes: [
      {
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        align: "right",
        key: "season_nandc.name",
        order: 4,
        label: "SEASON_NANDC",
        visible: true,
      },
      {
        align: "right",
        key: "start_date",
        order: 5,
        label: "DATE_START",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "end_date",
        order: 6,
        label: "DATE_END",
        type: FormatType.DATE,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/seasons/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/seasons/export" },
    import: { path: "/api/seasons/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        tooltip: "SEASON_CODE_TOOLTIP",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        tooltip: "SEASON_NAME_TOOLTIP",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "season_nandc",
        label: "SEASON_NANDC",
        labelKey: "name",
        tooltip: "SEASON_NANDC_TOOLTIP",
        type: ConfigurationFormType.Select,
        api: "/api/seasons-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "name",
        },
      },
      {
        key: "date_range",
        startDateField: "start_date",
        endDateField: "end_date",
        startDateLabel: "DATE_START",
        endDateLabel: "DATE_END",
        endDateTooltip: "DATE_INCLUDED",
        type: ConfigurationFormType.DateRangePicker,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "50%",
        required: true,
      },
      {
        key: "season_nandc",
        flex: "50%",
        required: false,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "50%",
        required: true,
      },
      {
        key: "season_nandc",
        flex: "50%",
        required: false,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
  },
};
